export default function Urgence404() {
  return (
    <section className="bg-slate-primary py-14 md:py-20">
      <div className="max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="w-16 h-16 mx-auto mb-6 flex items-center justify-center rounded-full bg-urgent/20">
          <i className="ri-alarm-warning-line text-3xl text-urgent" />
        </div>
        <h2 className="text-2xl md:text-3xl font-bold text-white mb-6">
          Vous avez une urgence toiture ?
        </h2>
        <a
          href="tel:+14184769950"
          aria-label="Appeler Couvreur-Lévis.com au 418-476-9950"
          title="Cliquez pour appeler"
          className="inline-flex items-center gap-3 bg-urgent hover:bg-urgent-dark text-white font-bold text-lg px-8 py-4 rounded-md transition-all duration-300 whitespace-nowrap"
        >
          <i className="ri-phone-line text-xl" />
          418-476-9950 — Urgence 7j/7
        </a>
        <p className="mt-4 text-white/60 text-sm">
          Réponse sous 30 min pour les urgences actives
        </p>
      </div>
    </section>
  );
}